import React, { PureComponent, useContext, Component } from 'react';
import { RicosContext, withRicosContext, withZIndexContext, RicosViewerContext } from 'ricos-context';
import { g as getRandomValue, O as OPTION_IMAGES_POOL, P as POLL_IMAGES_POOL, L as LAYOUTS, V as VISIBILITY_OPTIONS, t as toBackgroundString, a as POLL_TYPE } from './viewer-loadable2.js';
import { withEditorEvents } from 'wix-rich-content-editor-common/libs/EditorEventsContext';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { cloneDeep, clamp } from 'lodash';
import PropTypes from 'prop-types';
import cls from 'classnames';
import FlipMove from 'react-flip-move';
import Measure, { withContentRect } from 'react-measure';
import { getScaleImageSrc } from 'wix-rich-content-common/libs/imageUtils';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import ReactModal from 'react-modal';
import InfiniteScroll from 'react-infinite-scroller';
import { Image } from 'wix-rich-content-ui-components';
import '@loadable/component';
import 'ricos-types';

function _createForOfIteratorHelperLoose$i(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$i(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$i(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$i(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$i(o, minLen); }
function _arrayLikeToArray$i(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$m = Object.defineProperty;
var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
var __hasOwnProp$i = Object.prototype.hasOwnProperty;
var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$m = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$m(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$i = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$i.call(b, prop)) __defNormalProp$m(a, prop, b[prop]);
  if (__getOwnPropSymbols$i) {
    for (var _iterator = _createForOfIteratorHelperLoose$i(__getOwnPropSymbols$i(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$i.call(b, prop)) __defNormalProp$m(a, prop, b[prop]);
    }
  }
  return a;
};
var PollOptionPropTypes = PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  mediaId: PropTypes.string,
  count: PropTypes.number,
  rating: PropTypes.number
});
var PollPropTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  mediaId: PropTypes.string,
  settings: PropTypes.shape({
    multipleVotes: PropTypes.bool.isRequired,
    votesDisplay: PropTypes.bool.isRequired,
    votersDisplay: PropTypes.bool.isRequired,
    voteRole: PropTypes.string.isRequired,
    resultsVisibility: PropTypes.string.isRequired
  }).isRequired,
  options: PropTypes.arrayOf(PollOptionPropTypes).isRequired
};
var PollActionsPropTypes = {
  changePollTitle: PropTypes.func,
  changePollImage: PropTypes.func,
  updatePollOption: PropTypes.func,
  addOption: PropTypes.func,
  removeOption: PropTypes.func
};
var PollContextPropTypes = {
  poll: PropTypes.shape(__spreadValues$i(__spreadValues$i({}, PollPropTypes), PollActionsPropTypes))
};

function _createForOfIteratorHelperLoose$h(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$h(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$h(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$h(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$h(o, minLen); }
function _arrayLikeToArray$h(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$l = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
var __hasOwnProp$h = Object.prototype.hasOwnProperty;
var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$l = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$l(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$h = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$h.call(b, prop)) __defNormalProp$l(a, prop, b[prop]);
  if (__getOwnPropSymbols$h) {
    for (var _iterator = _createForOfIteratorHelperLoose$h(__getOwnPropSymbols$h(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$h.call(b, prop)) __defNormalProp$l(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps$4 = function __spreadProps(a, b) {
  return __defProps$4(a, __getOwnPropDescs$4(b));
};
var __publicField$9 = function __publicField(obj, key, value) {
  __defNormalProp$l(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var PollContext = /*#__PURE__*/React.createContext({});
var withPoll = function withPoll(WrappedComponent) {
  return function (props) {
    return /* @__PURE__ */React.createElement(PollContext.Consumer, null, function (contextValue) {
      return /* @__PURE__ */React.createElement(WrappedComponent, __spreadValues$h(__spreadValues$h({}, props), contextValue));
    });
  };
};
var PollContextProvider = /*#__PURE__*/function (_PureComponent) {
  function PollContextProvider(props) {
    var _this;
    var _a;
    _this = _PureComponent.call(this, props) || this;
    __publicField$9(_this, "state", {
      changePollTitle: _this.changePollTitle.bind(_this),
      updatePollOption: _this.updatePollOption.bind(_this),
      addOption: _this.addOption.bind(_this),
      removeOption: _this.removeOption.bind(_this),
      changePollImage: _this.changePollImage.bind(_this),
      fetchPoll: _this.fetchPoll.bind(_this),
      vote: _this.vote.bind(_this),
      unvote: _this.unvote.bind(_this),
      getVoters: _this.getVoters.bind(_this),
      poll: _this.props.poll
    });
    __publicField$9(_this, "syncPoll", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var dto, poll;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            poll = _this.populateWithData(_this.state.poll);
            if (!poll.id) {
              _context.next = 7;
              break;
            }
            _context.next = 4;
            return _this.pollApiClient.updatePoll(poll);
          case 4:
            dto = _context.sent;
            _context.next = 10;
            break;
          case 7:
            _context.next = 9;
            return _this.pollApiClient.createPoll(poll);
          case 9:
            dto = _context.sent;
          case 10:
            _this.props.setPoll(dto);
            console.debug("polls publish callback");
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _this.pollApiClient = (_a = props.settings) == null ? void 0 : _a.pollServiceApi;
    return _this;
  }
  _inheritsLoose(PollContextProvider, _PureComponent);
  var _proto = PollContextProvider.prototype;
  _proto.componentWillReceiveProps = function componentWillReceiveProps(props) {
    var _a;
    if (!((_a = props.settings) == null ? void 0 : _a.pollServiceApi) && props.settings.siteToken !== this.props.settings.siteToken) {
      this.fetchPoll();
    }
    if (JSON.stringify(props.poll) !== JSON.stringify(this.props.poll)) {
      this.setState(function () {
        return {
          poll: props.poll
        };
      });
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    var editorEvents = this.props.editorEvents;
    editorEvents == null ? void 0 : editorEvents.subscribe("plugin:publish", this.syncPoll);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var _a;
    (_a = this.props.editorEvents) == null ? void 0 : _a.unsubscribe("plugin:publish", this.syncPoll);
  };
  _proto.fetchPoll = /*#__PURE__*/function () {
    var _fetchPoll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _a, _b, poll;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (this.state.poll.id) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.next = 4;
            return this.pollApiClient.fetchPoll(this.state.poll.id);
          case 4:
            poll = _context2.sent;
            (_b = (_a = this.props).setPoll) == null ? void 0 : _b.call(_a, poll);
            this.setState(function () {
              return {
                poll: poll
              };
            });
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function fetchPoll() {
      return _fetchPoll.apply(this, arguments);
    }
    return fetchPoll;
  }();
  _proto.populateWithData = function populateWithData(poll) {
    var t = this.props.t;
    poll.title = poll.title || t("Poll_Editor_Question_Placeholder");
    poll.options = poll.options.map(function (option) {
      return __spreadProps$4(__spreadValues$h({}, option), {
        title: option.title || t("Poll_Editor_Answer_Placeholder")
      });
    });
    return poll;
  };
  _proto.updatePoll = function updatePoll(poll) {
    this.props.setPoll(Object.assign({}, this.state.poll, poll));
  };
  _proto.vote = /*#__PURE__*/function () {
    var _vote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(optionId) {
      var poll;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return this.pollApiClient.vote(this.state.poll.id, optionId);
          case 2:
            poll = _context3.sent;
            this.setState({
              poll: poll
            });
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function vote(_x) {
      return _vote.apply(this, arguments);
    }
    return vote;
  }();
  _proto.unvote = /*#__PURE__*/function () {
    var _unvote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(optionId) {
      var poll;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return this.pollApiClient.unvote(this.state.poll.id, optionId);
          case 2:
            poll = _context4.sent;
            this.setState({
              poll: poll
            });
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function unvote(_x2) {
      return _unvote.apply(this, arguments);
    }
    return unvote;
  }();
  _proto.getVoters = function getVoters(optionId, params) {
    return this.pollApiClient.getVoters(this.state.poll.id, optionId, params);
  };
  _proto.changePollTitle = function changePollTitle(title) {
    return this.updatePoll({
      title: title
    });
  };
  _proto.changePollImage = function changePollImage(url) {
    var imageData = {
      image: {
        src: {
          url: url
        }
      }
    };
    return this.updatePoll(imageData);
  };
  _proto.updatePollOption = function updatePollOption(index, option) {
    var poll = cloneDeep(this.state.poll);
    poll.options[index] = option;
    return this.updatePoll({
      options: poll.options
    });
  };
  _proto.addOption = function addOption() {
    var poll = cloneDeep(this.state.poll);
    var imageData = {
      image: {
        src: {
          url: getRandomValue(OPTION_IMAGES_POOL)
        }
      }
    };
    poll.options.push(__spreadValues$h({
      title: ""
    }, imageData));
    return this.updatePoll({
      options: poll.options
    });
  };
  _proto.removeOption = function removeOption(index) {
    var poll = cloneDeep(this.state.poll);
    poll.options.splice(index, 1);
    return this.updatePoll({
      options: poll.options
    });
  };
  _proto.render = function render() {
    var children = this.props.children;
    return /* @__PURE__ */React.createElement(PollContext.Provider, {
      value: this.state
    }, children);
  };
  return PollContextProvider;
}(PureComponent);
__publicField$9(PollContextProvider, "propTypes", {
  editorEvents: PropTypes.shape({
    subscribe: PropTypes.func,
    unsubscribe: PropTypes.func
  }),
  settings: PropTypes.shape({
    siteToken: PropTypes.string,
    isWebView: PropTypes.bool,
    getSiteMembers: PropTypes.func,
    pollServiceApi: PropTypes.object
  }),
  poll: PropTypes.shape(PollPropTypes),
  setPoll: PropTypes.func,
  children: PropTypes.any,
  t: PropTypes.func
});

function _createForOfIteratorHelperLoose$g(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$g(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$g(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$g(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$g(o, minLen); }
function _arrayLikeToArray$g(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$k = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$k = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$k(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$g = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$g.call(b, prop)) __defNormalProp$k(a, prop, b[prop]);
  if (__getOwnPropSymbols$g) {
    for (var _iterator = _createForOfIteratorHelperLoose$g(__getOwnPropSymbols$g(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$g.call(b, prop)) __defNormalProp$k(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps$3 = function __spreadProps(a, b) {
  return __defProps$3(a, __getOwnPropDescs$3(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$g.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$g) {
    for (var _iterator2 = _createForOfIteratorHelperLoose$g(__getOwnPropSymbols$g(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum$g.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var RCEHelpersPropTypes = {
  rce: PropTypes.shape({
    isViewMode: PropTypes.bool.isRequired,
    setInPluginEditingMode: PropTypes.func,
    helpers: PropTypes.shape({
      handleFileUpload: PropTypes.func
    }),
    getSiteMembers: PropTypes.func
  }).isRequired,
  t: PropTypes.func.isRequired,
  layout: PropTypes.object.isRequired,
  design: PropTypes.object.isRequired
};
var RCEHelpersContext = /*#__PURE__*/React.createContext({});
var withRCEHelpers = function withRCEHelpers(WrappedComponent) {
  return function (props) {
    return /* @__PURE__ */React.createElement(RCEHelpersContext.Consumer, null, function (_a) {
      var _b = _a,
        layout = _b.layout,
        design = _b.design,
        t = _b.t,
        rest = __objRest(_b, ["layout", "design", "t"]);
      return /* @__PURE__ */React.createElement(WrappedComponent, __spreadProps$3(__spreadValues$g({}, props), {
        rce: rest,
        t: t,
        layout: layout,
        design: design
      }));
    });
  };
};

function _createForOfIteratorHelperLoose$f(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$f(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$f(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$f(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$f(o, minLen); }
function _arrayLikeToArray$f(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$j = Object.defineProperty;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$j = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$j(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$f = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$f.call(b, prop)) __defNormalProp$j(a, prop, b[prop]);
  if (__getOwnPropSymbols$f) {
    for (var _iterator = _createForOfIteratorHelperLoose$f(__getOwnPropSymbols$f(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$f.call(b, prop)) __defNormalProp$j(a, prop, b[prop]);
    }
  }
  return a;
};
var AddIcon = function AddIcon(props) {
  return /* @__PURE__ */React.createElement("svg", __spreadValues$f({
    width: "72",
    height: "72",
    viewBox: "0 0 72 72"
  }, props), /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.4 12v21.6H60v4.8H38.4V60h-4.8V38.4H12v-4.8h21.6V12h4.8z"
  }));
};

function _createForOfIteratorHelperLoose$e(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$e(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$e(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$e(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$e(o, minLen); }
function _arrayLikeToArray$e(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$i = Object.defineProperty;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$i = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$i(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$e = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$e.call(b, prop)) __defNormalProp$i(a, prop, b[prop]);
  if (__getOwnPropSymbols$e) {
    for (var _iterator = _createForOfIteratorHelperLoose$e(__getOwnPropSymbols$e(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$e.call(b, prop)) __defNormalProp$i(a, prop, b[prop]);
    }
  }
  return a;
};
var CheckIcon = function CheckIcon(props) {
  return /* @__PURE__ */React.createElement("svg", __spreadValues$e({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, props), /* @__PURE__ */React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */React.createElement("g", {
    transform: "translate(-496.000000, 0.000000)"
  }, /* @__PURE__ */React.createElement("g", null, /* @__PURE__ */React.createElement("polyline", {
    stroke: "#FFFFFF",
    strokeWidth: "2",
    points: "508 23.8193359 508 64 0 64 0 12 496.790039 12"
  }), /* @__PURE__ */React.createElement("g", {
    transform: "translate(496.000000, 0.000000)"
  }, /* @__PURE__ */React.createElement("g", null, /* @__PURE__ */React.createElement("circle", {
    fill: "#FFFFFF",
    cx: "12",
    cy: "12",
    r: "12"
  }), /* @__PURE__ */React.createElement("g", {
    transform: "translate(5.000000, 8.000000)",
    fill: "currentColor"
  }, /* @__PURE__ */React.createElement("polygon", {
    points: "12.2335029 0.239154296 13.4174702 1.3883133 5.59026761 9.73257326 0.586372643 5.73025155 1.59665912 4.42329121 5.43146554 7.49052765"
  }))), /* @__PURE__ */React.createElement("g", {
    transform: "translate(5.000000, 8.000000)"
  }))))));
};

function _createForOfIteratorHelperLoose$d(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$d(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$d(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$d(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$d(o, minLen); }
function _arrayLikeToArray$d(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$h = Object.defineProperty;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$h = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$h(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$d = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$d.call(b, prop)) __defNormalProp$h(a, prop, b[prop]);
  if (__getOwnPropSymbols$d) {
    for (var _iterator = _createForOfIteratorHelperLoose$d(__getOwnPropSymbols$d(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$d.call(b, prop)) __defNormalProp$h(a, prop, b[prop]);
    }
  }
  return a;
};
var LoaderIcon = function LoaderIcon(props) {
  return /* @__PURE__ */React.createElement("svg", __spreadValues$d({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /* @__PURE__ */React.createElement("defs", null, /* @__PURE__ */React.createElement("path", {
    id: "file-upload-loader-icon-path",
    d: "M14.064 5.948l1.518-.507A8 8 0 1 1 10.473.39l-.506 1.519a6.4 6.4 0 1 0 4.097 4.04z"
  })), /* @__PURE__ */React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 4)"
  }, /* @__PURE__ */React.createElement("mask", {
    id: "file-upload-loader-mask",
    fill: "#fff"
  }, /* @__PURE__ */React.createElement("use", {
    xlinkHref: "#file-upload-loader-icon-path"
  })), /* @__PURE__ */React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#file-upload-loader-icon-path"
  }), /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M-4-4h24v24H-4z",
    mask: "url(#file-upload-loader-mask)"
  })));
};

function _createForOfIteratorHelperLoose$c(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$c(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$c(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$c(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$c(o, minLen); }
function _arrayLikeToArray$c(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$g = Object.defineProperty;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$g = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$g(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$c = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$c.call(b, prop)) __defNormalProp$g(a, prop, b[prop]);
  if (__getOwnPropSymbols$c) {
    for (var _iterator = _createForOfIteratorHelperLoose$c(__getOwnPropSymbols$c(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$c.call(b, prop)) __defNormalProp$g(a, prop, b[prop]);
    }
  }
  return a;
};
var NonEditableIcon = function NonEditableIcon(props) {
  return /* @__PURE__ */React.createElement("svg", __spreadValues$c({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15"
  }, props), /* @__PURE__ */React.createElement("g", {
    id: "Polls-Desktop",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */React.createElement("g", {
    id: "WOW-Poll-/-Added-Poll-/-Edit-Mode",
    transform: "translate(-875.000000, -558.000000)"
  }, /* @__PURE__ */React.createElement("g", {
    id: "Group-6",
    transform: "translate(871.000000, 553.000000)"
  }, /* @__PURE__ */React.createElement("g", {
    id: "01-Foundation-/-Icon-Medium-24-(Default)-/-01-Actions-/-01-Edit",
    fill: "#FFFFFF"
  }, /* @__PURE__ */React.createElement("path", {
    d: "M16.679,5.60187506 L18.381,7.30587506 C19.207,8.13287506 19.207,9.47787506 18.381,10.3058751 L10.211,18.4858751 L4,19.9998751 L5.512,13.7818751 L13.682,5.60187506 C14.481,4.79987506 15.878,4.79887506 16.679,5.60187506 Z M8.66091072,16.0462125 L9.973,17.3598751 L15.625,11.7018751 L12.289,8.36087506 L6.637,14.0198751 L7.95422762,15.3386821 L11.1467061,12.1463747 C11.3419735,11.9511178 11.6585559,11.9511262 11.8538129,12.1463936 C12.0490698,12.341661 12.0490613,12.6582435 11.8537939,12.8535004 L8.66091072,16.0462125 Z M16.306,11.0198751 L17.7,9.62387506 C18.15,9.17287506 18.15,8.43787506 17.7,7.98687506 L15.998,6.28287506 C15.561,5.84587506 14.801,5.84687506 14.364,6.28287506 L12.97,7.67887506 L16.306,11.0198751 Z M5.426,18.5738751 L8.995,17.7438751 L6.254,14.9988751 L5.426,18.5738751 Z"
  })), /* @__PURE__ */React.createElement("line", {
    x1: "7",
    y1: "7",
    x2: "17.9601551",
    y2: "17.9601551",
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  })))));
};

function _createForOfIteratorHelperLoose$b(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$b(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$b(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$b(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$b(o, minLen); }
function _arrayLikeToArray$b(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$f = Object.defineProperty;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$f(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$b = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$b.call(b, prop)) __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$b) {
    for (var _iterator = _createForOfIteratorHelperLoose$b(__getOwnPropSymbols$b(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$b.call(b, prop)) __defNormalProp$f(a, prop, b[prop]);
    }
  }
  return a;
};
var RemoveIcon = function RemoveIcon(props) {
  return /* @__PURE__ */React.createElement("svg", __spreadValues$b({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.23 7l.77.77L12.769 12 17 16.23l-.77.77L12 12.769 7.77 17 7 16.23 11.23 12 7 7.77 7.77 7 12 11.231 16.23 7z"
  }));
};

function _createForOfIteratorHelperLoose$a(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$a(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$a(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$a(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$a(o, minLen); }
function _arrayLikeToArray$a(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$e = Object.defineProperty;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$e(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$a = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$a.call(b, prop)) __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$a) {
    for (var _iterator = _createForOfIteratorHelperLoose$a(__getOwnPropSymbols$a(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$a.call(b, prop)) __defNormalProp$e(a, prop, b[prop]);
    }
  }
  return a;
};
var ReplaceIcon = function ReplaceIcon(props) {
  return /* @__PURE__ */React.createElement("svg", __spreadValues$a({
    width: "16",
    height: "18",
    viewBox: "0 0 16 18"
  }, props), /* @__PURE__ */React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /* @__PURE__ */React.createElement("path", {
    d: "M3.256 3.468c2.582-2.335 6.447-2.371 9.064-.239l-2.075.079c-.267.01-.475.232-.464.5.01.26.225.464.482.464h.018l3.186-.118c.26-.01.464-.221.464-.482v-.036V3.615l-.118-3.15c-.01-.268-.235-.475-.5-.465-.268.011-.475.233-.464.5l.075 1.975C11.628 1.415 10.031.8 8.324.715 6.21.608 4.178 1.333 2.61 2.754.453 4.708-.462 7.679.224 10.508c.054.221.25.367.468.367.04 0 .075-.003.114-.014.257-.064.418-.325.354-.582-.6-2.486.2-5.096 2.096-6.81zM15.767 6.983c-.064-.258-.325-.418-.582-.354-.257.064-.418.325-.354.582.604 2.486-.2 5.097-2.096 6.81-1.332 1.204-3.004 1.797-4.668 1.797-1.59 0-3.175-.539-4.454-1.603l2.1-.19c.265-.025.461-.257.436-.525-.025-.267-.257-.46-.525-.435l-3.175.285c-.264.025-.46.258-.436.525L2.3 17.05c.021.25.232.44.479.44.014 0 .028 0 .042-.004.265-.025.461-.257.436-.525l-.171-1.932c1.296 1.05 2.885 1.66 4.582 1.746.136.008.271.011.403.011 1.968 0 3.84-.721 5.311-2.05 2.157-1.953 3.072-4.921 2.386-7.753z"
  })));
};

var styles$6 = {"fontElementMap":"X-08X","container":"gIj9v","fullscreen":"cgYt-","background_overlay":"fylrR","with_image":"qRsQu","options":"RJyJI","webview":"cWK7P","grid":"_2kkJ4","option":"zTXik","cta_button":"E3tjg","add_option":"_3KyrR","see_more":"SEDOr","list":"aFpqV","column":"ZLU1o","additional_note":"M59mx","spinner":"I2AC2","spin":"btDv8","shown":"PYE2l","error":"j6uuk"};

var ROOT = "pollsViewer";
var POLLS_MULTIPLE_ANSWER_TEXT = "pollsMultipleAnswerText";
var POLLS_QUESTION_IMAGE = "pollsQuestionImage";
var POLLS_ANSWER_IMAGE = "pollsAnswerImage";
var POLLS_ANSWER_ITEMS = "pollsAnswerItems";
var POLLS_QUESTION_TEXT_INPUT = "pollsQuestionTextInput";
var POLLS_ANSWER_TEXT_INPUT = "pollsAnswerTextInput";
var POLLS_ADD_ANSWER_BUTTON = "pollsAddAnswerItemButton";
var POLLS_REMOVE_ANSWER_BUTTON = "pollsRemoveAnswerItemButton";
var POLLS_ITEM_PERCENTAGE_PREVIEW = "pollsItemsPercentagePreview";

var styles$5 = {"container":"TWSXE","disabled":"luQ5x","imageInput":"rHnON","overlay":"_1r5e9","text":"Gmjb4","shown":"_3HUU7","hide":"YyCGa","spinner":"GdwD6","spin":"eXCeX"};

var ImageUploadPropTypes = {
  dataHook: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  imagesPool: PropTypes.array,
  small: PropTypes.bool,
  disabled: PropTypes.bool
};

function _createForOfIteratorHelperLoose$9(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$9(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$9(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$9(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen); }
function _arrayLikeToArray$9(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$d = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$d(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$9 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$9.call(b, prop)) __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$9) {
    for (var _iterator = _createForOfIteratorHelperLoose$9(__getOwnPropSymbols$9(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$9.call(b, prop)) __defNormalProp$d(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps$2 = function __spreadProps(a, b) {
  return __defProps$2(a, __getOwnPropDescs$2(b));
};
var __publicField$8 = function __publicField(obj, key, value) {
  __defNormalProp$d(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var ImageUploadComponent = /*#__PURE__*/function (_PureComponent) {
  function ImageUploadComponent() {
    var _this;
    _this = _PureComponent.apply(this, arguments) || this;
    __publicField$8(_this, "state", {
      value: _this.props.value || getRandomValue(POLL_IMAGES_POOL),
      backgroundImage: null,
      loading: false
    });
    __publicField$8(_this, "$label", /*#__PURE__*/React.createRef());
    __publicField$8(_this, "handleFileUpload", function (_ref) {
      var data = _ref.data;
      _this.setState({
        value: "https://static.wixstatic.com/media/" + data.file_name,
        loading: false
      }, function () {
        _this.updateBackgroundImage();
        setTimeout(function () {
          return _this.sync();
        });
      });
    });
    __publicField$8(_this, "handleFileReadLoad", function (backgroundImage, file) {
      var helpers = _this.props.rce.helpers;
      _this.setState({
        backgroundImage: "url(" + backgroundImage + ")",
        loading: false
      });
      if (helpers == null ? void 0 : helpers.handleFileUpload) {
        _this.setState({
          loading: true
        });
        helpers.handleFileUpload(file, _this.handleFileUpload);
      }
    });
    __publicField$8(_this, "handleInputChange", function (e) {
      _this.handleFileChange(Array.from(e.target.files));
      e.target.value = null;
    });
    __publicField$8(_this, "handleFileChange", function (_ref2) {
      var file = _ref2[0];
      var reader = new FileReader();
      _this.setState({
        loading: true
      });
      reader.onload = function (e) {
        return _this.handleFileReadLoad(e.target.result, file);
      };
      reader.readAsDataURL(file);
    });
    __publicField$8(_this, "handleKeyPress", function (e) {
      var _a;
      var enterOrSpace = e.key === "Enter" || e.key === " " || e.key === "Spacebar" || e.which === 13 || e.which === 32;
      if (enterOrSpace) {
        e.preventDefault();
        (_a = _this.$label.current) == null ? void 0 : _a.click();
      }
    });
    __publicField$8(_this, "handleFocus", function (e) {
      e.stopPropagation();
      var rce = _this.props.rce;
      rce.setInPluginEditingMode(true);
    });
    __publicField$8(_this, "handleBlur", function () {
      var rce = _this.props.rce;
      rce.setInPluginEditingMode(false);
    });
    return _this;
  }
  _inheritsLoose(ImageUploadComponent, _PureComponent);
  var _proto = ImageUploadComponent.prototype;
  _proto.componentWillReceiveProps = function componentWillReceiveProps(props) {
    var _this2 = this;
    var value = props.value,
      contentRect = props.contentRect;
    var _this$props = this.props,
      prevValue = _this$props.value,
      prevContentRect = _this$props.contentRect;
    if (value !== prevValue) {
      this.setState({
        value: value
      }, function () {
        return _this2.updateBackgroundImage();
      });
    }
    if (JSON.stringify(contentRect.bounds) !== JSON.stringify(prevContentRect.bounds)) {
      this.updateBackgroundImage(contentRect.bounds);
    }
  };
  _proto.sync = function sync() {
    this.props.onChange(this.state.value);
  };
  _proto.updateBackgroundImage = function updateBackgroundImage(bounds) {
    if (bounds === void 0) {
      bounds = this.props.contentRect.bounds;
    }
    var value = this.state.value;
    if (!bounds.width || !bounds.height) {
      return null;
    }
    var backgroundImage = "url(" + getScaleImageSrc(value, bounds.width, bounds.height) + ")";
    this.setState(function () {
      return {
        backgroundImage: backgroundImage
      };
    });
  };
  _proto.render = function render() {
    var _cls, _cls2, _cls3;
    var _this$props2 = this.props,
      dataHook = _this$props2.dataHook,
      className = _this$props2.className,
      rce = _this$props2.rce,
      small = _this$props2.small,
      disabled = _this$props2.disabled,
      measureRef = _this$props2.measureRef,
      _this$props2$style = _this$props2.style,
      style = _this$props2$style === void 0 ? {} : _this$props2$style;
    var _this$state = this.state,
      loading = _this$state.loading,
      backgroundImage = _this$state.backgroundImage;
    return /* @__PURE__ */React.createElement("div", {
      ref: measureRef,
      className: cls(styles$5.container, className, (_cls = {}, _cls[styles$5.disabled] = rce.isViewMode || disabled, _cls)),
      style: __spreadProps$2(__spreadValues$9({}, style), {
        backgroundImage: backgroundImage
      }),
      tabIndex: rce.isViewMode ? -1 : 0,
      "aria-hidden": rce.isViewMode,
      role: "button",
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeyPress: this.handleKeyPress,
      "data-hook": dataHook
    }, /* @__PURE__ */React.createElement("label", {
      ref: this.$label
    }, /* @__PURE__ */React.createElement("input", {
      type: "file",
      disabled: rce.isViewMode || disabled,
      onChange: this.handleInputChange,
      accept: "image/*",
      tabIndex: -1,
      className: styles$5.imageInput
    }), /* @__PURE__ */React.createElement("div", {
      className: cls(styles$5.overlay, (_cls2 = {}, _cls2[styles$5.shown] = loading, _cls2))
    }, loading ? /* @__PURE__ */React.createElement(LoaderIcon, {
      width: small ? 24 : 48,
      height: small ? 24 : 48,
      className: styles$5.spinner
    }) : /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(ReplaceIcon, null), /* @__PURE__ */React.createElement("p", {
      className: cls(styles$5.text, (_cls3 = {}, _cls3[styles$5.hide] = small, _cls3))
    }, "Change Image")))));
  };
  return ImageUploadComponent;
}(PureComponent);
__publicField$8(ImageUploadComponent, "propTypes", __spreadValues$9(__spreadValues$9({}, ImageUploadPropTypes), RCEHelpersPropTypes));
__publicField$8(ImageUploadComponent, "defaultProps", {
  imagesPool: [],
  disabled: false
});
var ImageUpload = withContentRect("bounds")(withRCEHelpers(ImageUploadComponent));

var styles$4 = {"root":"HkFL2","text":"FrDZo","input":"_9Pfgd","small":"syxkV","medium":"Vvztn","large":"nl-Rv","webview":"tzJoU","endAdornment":"-zo9h","shown":"yTBTW","value":"gY-Um","spinner":"kxGwx","spin":"w3aun"};

function _createForOfIteratorHelperLoose$8(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$8(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$8(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$8(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen); }
function _arrayLikeToArray$8(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$c = Object.defineProperty;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$c(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$8 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$8.call(b, prop)) __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$8) {
    for (var _iterator = _createForOfIteratorHelperLoose$8(__getOwnPropSymbols$8(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$8.call(b, prop)) __defNormalProp$c(a, prop, b[prop]);
    }
  }
  return a;
};
var __publicField$7 = function __publicField(obj, key, value) {
  __defNormalProp$c(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var TextFieldComponent = /*#__PURE__*/function (_React$PureComponent) {
  function TextFieldComponent() {
    var _this;
    _this = _React$PureComponent.apply(this, arguments) || this;
    __publicField$7(_this, "$el", /*#__PURE__*/React.createRef());
    __publicField$7(_this, "state", {
      placeholder: _this.props.placeholder,
      rows: 1,
      syncing: false,
      isFocused: false
    });
    __publicField$7(_this, "handleWindowResizeEvent", function () {
      return setTimeout(function () {
        return _this.resize();
      });
    });
    __publicField$7(_this, "handleFocus", function (e) {
      e.stopPropagation();
      setTimeout(function () {
        return _this.resize();
      });
      _this.hidePlaceholder();
      _this.props.rce.setInPluginEditingMode(true);
      _this.setState({
        isFocused: true
      });
    });
    __publicField$7(_this, "handleBlur", function () {
      setTimeout(function () {
        return _this.resize();
      });
      _this.showPlaceholder();
      _this.props.rce.setInPluginEditingMode(false);
      _this.setState({
        isFocused: false
      });
    });
    __publicField$7(_this, "handleChange", function (event) {
      _this.props.onChange(event.target.value);
      _this.resize();
    });
    return _this;
  }
  _inheritsLoose(TextFieldComponent, _React$PureComponent);
  var _proto = TextFieldComponent.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var rce = this.props.rce;
    var isEditMode = !rce.isViewMode;
    if (isEditMode) {
      this.resize();
    }
    this.handleAutoFocus();
    window == null ? void 0 : window.addEventListener("resize", this.handleWindowResizeEvent);
  };
  _proto.componentDidUpdate = function componentDidUpdate(props) {
    if (this.props.rce.isViewMode === props.rce.isViewMode) {
      return;
    }
    this.handleAutoFocus();
  };
  _proto.handleAutoFocus = function handleAutoFocus() {
    var _a;
    var _this$props = this.props,
      rce = _this$props.rce,
      autofocus = _this$props.autofocus;
    var isEditMode = !rce.isViewMode;
    if (autofocus && isEditMode) {
      (_a = this.$el.current) == null ? void 0 : _a.focus();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window == null ? void 0 : window.removeEventListener("resize", this.handleWindowResizeEvent);
  };
  _proto.hidePlaceholder = function hidePlaceholder() {
    this.setState({
      placeholder: ""
    });
  };
  _proto.showPlaceholder = function showPlaceholder() {
    this.setState({
      placeholder: this.props.placeholder
    });
  };
  _proto.handleKeyDown = function handleKeyDown(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  };
  _proto.resize = function resize() {
    if (!this.$el.current) {
      return;
    }
    var computedStyles = getComputedStyle(this.$el.current);
    var lineHeight = parseInt(computedStyles.lineHeight);
    var paddingTop = parseInt(computedStyles.paddingTop);
    var paddingBottom = parseInt(computedStyles.paddingBottom);
    this.$el.current.rows = 1;
    var scrollHeight = this.$el.current.scrollHeight;
    this.$el.current.rows = this.state.rows;
    var contentHeight = scrollHeight - (paddingTop + paddingBottom);
    var rows = Math.ceil(clamp(contentHeight / lineHeight, 1, Infinity));
    this.setState({
      rows: rows
    });
  };
  _proto.render = function render() {
    var _ref2, _cls2;
    var _this$props2 = this.props,
      dataHook = _this$props2.dataHook,
      textAutoResize = _this$props2.textAutoResize,
      className = _this$props2.className,
      rce = _this$props2.rce,
      endAdornment = _this$props2.endAdornment,
      style = _this$props2.style,
      children = _this$props2.children,
      startAdornment = _this$props2.startAdornment,
      maxLength = _this$props2.maxLength,
      disabled = _this$props2.disabled,
      value = _this$props2.value;
    var _this$state = this.state,
      placeholder = _this$state.placeholder,
      rows = _this$state.rows,
      syncing = _this$state.syncing,
      isFocused = _this$state.isFocused;
    if (rce.isViewMode || rce.isPreview) {
      var _ref, _cls;
      return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("p", {
        style: style,
        className: cls(styles$4.text, className, textAutoResize && (_ref = {}, _ref[styles$4.small] = value.length > 120, _ref[styles$4.medium] = value.length <= 120, _ref[styles$4.large] = value.length <= 80, _ref), (_cls = {}, _cls[styles$4.webview] = rce.isWebView, _cls))
      }, startAdornment, children, /* @__PURE__ */React.createElement("span", {
        className: styles$4.value,
        "data-hook": dataHook
      }, this.props.value || this.props.placeholder)));
    }
    return /* @__PURE__ */React.createElement("div", {
      className: styles$4.root
    }, startAdornment, /* @__PURE__ */React.createElement("textarea", {
      "data-hook": dataHook,
      disabled: disabled,
      maxLength: maxLength,
      style: style,
      ref: this.$el,
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      placeholder: placeholder,
      value: value,
      rows: rows,
      onKeyDown: this.handleKeyDown,
      className: cls(styles$4.input, className, textAutoResize && (_ref2 = {}, _ref2[styles$4.small] = value.length > 120, _ref2[styles$4.medium] = value.length <= 120, _ref2[styles$4.large] = value.length <= 80, _ref2)),
      onClick: void 0
    }), /* @__PURE__ */React.createElement("span", {
      className: cls(styles$4.endAdornment, (_cls2 = {}, _cls2[styles$4.shown] = syncing || isFocused, _cls2))
    }, syncing ? /* @__PURE__ */React.createElement(LoaderIcon, {
      className: styles$4.spinner
    }) : endAdornment));
  };
  return TextFieldComponent;
}(React.PureComponent);
var TextField = withRCEHelpers(TextFieldComponent);
TextFieldComponent.defaultProps = {
  maxLength: 500,
  disabled: false
};
TextFieldComponent.propTypes = __spreadValues$8({
  dataHook: PropTypes.string,
  autofocus: PropTypes.bool,
  maxLength: PropTypes.number,
  value: PropTypes.string,
  disabled: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  textAutoResize: PropTypes.bool,
  startAdornment: PropTypes.node,
  endAdornment: PropTypes.node
}, RCEHelpersPropTypes);

var styles$3 = {"title":"_0Gw0i","image":"_1r9qx","webview":"lgE3b"};

function _createForOfIteratorHelperLoose$7(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$7(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$7(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }
function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$b = Object.defineProperty;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$b(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$7 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$7.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$7) {
    for (var _iterator = _createForOfIteratorHelperLoose$7(__getOwnPropSymbols$7(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$7.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
    }
  }
  return a;
};
var PollHeaderComponent = /*#__PURE__*/function (_PureComponent) {
  function PollHeaderComponent() {
    return _PureComponent.apply(this, arguments) || this;
  }
  _inheritsLoose(PollHeaderComponent, _PureComponent);
  var _proto = PollHeaderComponent.prototype;
  _proto.render = function render() {
    var _cls;
    var _a, _b, _c;
    var _this$props = this.props,
      poll = _this$props.poll,
      changePollTitle = _this$props.changePollTitle,
      changePollImage = _this$props.changePollImage,
      layout = _this$props.layout,
      t = _this$props.t,
      rce = _this$props.rce;
    return /* @__PURE__ */React.createElement("div", {
      className: cls(styles$3.header, (_cls = {}, _cls[styles$3.webview] = rce.isWebView, _cls))
    }, /* @__PURE__ */React.createElement(TextField, {
      autofocus: true,
      textAutoResize: true,
      maxLength: 160,
      className: styles$3.title,
      value: poll.title,
      onChange: changePollTitle,
      placeholder: t("Poll_Editor_Question_Placeholder"),
      dataHook: POLLS_QUESTION_TEXT_INPUT
    }), ((_a = layout.poll) == null ? void 0 : _a.enableImage) && /* @__PURE__ */React.createElement(ImageUpload, {
      dataHook: POLLS_QUESTION_IMAGE,
      disabled: rce.isPreview,
      className: styles$3.image,
      value: (_c = (_b = poll.image) == null ? void 0 : _b.src) == null ? void 0 : _c.url,
      onChange: changePollImage
    }));
  };
  return PollHeaderComponent;
}(PureComponent);
var PollHeader = withRCEHelpers(withPoll(PollHeaderComponent));
PollHeaderComponent.propTypes = __spreadValues$7(__spreadValues$7({}, PollContextPropTypes), RCEHelpersPropTypes);

var styles$2 = {"option":"ezk1w","user_choice":"O5gnb","check":"wtLQt","image":"UzqYF","input":"_7iMAY","title":"ESvyY","centered":"wb42n","with_result":"fSw0x","list":"bNKg0","with_image":"gayFR","progress":"_070-q","progress_value":"AVow1","label":"PugUY","cta":"o-0OZ","adornment_icon":"KgNTH","remove":"yQY6c","removeButton":"to5rQ","removeButtonIcon":"LMEOL","overlay":"Mdkxo","shown":"PlCNF","dark":"_3DWZr","spinner":"VI-uF","spin":"yWav-"};

var OptionPropTypes = {
  option: PollOptionPropTypes,
  removeEnabled: PropTypes.bool,
  update: PropTypes.func,
  remove: PropTypes.func,
  vote: PropTypes.func,
  unvote: PropTypes.func,
  poll: PropTypes.object,
  imageEnabled: PropTypes.bool,
  voteEnabled: PropTypes.bool,
  showResults: PropTypes.bool
};

function _createForOfIteratorHelperLoose$6(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }
function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$a = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$a(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$6 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$6.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$6) {
    for (var _iterator = _createForOfIteratorHelperLoose$6(__getOwnPropSymbols$6(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$6.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps$1 = function __spreadProps(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
var __publicField$6 = function __publicField(obj, key, value) {
  __defNormalProp$a(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var PollOptionBase = /*#__PURE__*/function (_React$PureComponent) {
  function PollOptionBase() {
    var _this;
    _this = _React$PureComponent.apply(this, arguments) || this;
    __publicField$6(_this, "state", {
      loading: false,
      checked: _this.isUserChoice()
    });
    __publicField$6(_this, "handleRemove", function (e) {
      e.stopPropagation();
      _this.props.remove();
    });
    __publicField$6(_this, "handleVoteClick", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var _a, _this$props$rce, validateUser, onBeforeVote, preventInteraction, preventVoting, vote, onVoteClick;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props$rce = _this.props.rce, validateUser = _this$props$rce.validateUser, onBeforeVote = _this$props$rce.onBeforeVote, preventInteraction = _this$props$rce.preventInteraction, preventVoting = _this$props$rce.preventVoting;
              vote = (_a = _this.props.poll.settings.permissions) == null ? void 0 : _a.vote;
              onVoteClick = onBeforeVote || validateUser;
              e.preventDefault();
              if (!(e.keyCode || preventInteraction || preventVoting)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              if (onVoteClick) {
                onVoteClick({
                  voteRole: vote
                }).then(_this.toggleVote.bind(_this), function () {});
              } else {
                _this.toggleVote();
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    __publicField$6(_this, "handleTitleChange", function (title) {
      var _this$props = _this.props,
        update = _this$props.update,
        option = _this$props.option;
      return update(__spreadProps$1(__spreadValues$6({}, option), {
        title: title
      }));
    });
    __publicField$6(_this, "handleImageChange", function (url) {
      var _this$props2 = _this.props,
        update = _this$props2.update,
        option = _this$props2.option;
      var newOption = __spreadProps$1(__spreadValues$6({}, option), {
        image: {
          src: {
            url: url
          }
        }
      });
      return update(newOption);
    });
    return _this;
  }
  _inheritsLoose(PollOptionBase, _React$PureComponent);
  var _proto = PollOptionBase.prototype;
  _proto.isEditAllowed = function isEditAllowed() {
    return !this.props.option.count && !this.props.rce.isPreview;
  };
  _proto.isUserChoice = function isUserChoice() {
    var _a;
    var _this$props3 = this.props,
      poll = _this$props3.poll,
      option = _this$props3.option;
    return !!((_a = poll.ownVotes) == null ? void 0 : _a.includes(option.id));
  };
  _proto.isViewMode = function isViewMode() {
    return this.props.rce.isViewMode;
  };
  _proto.isGridLayout = function isGridLayout() {
    var _a;
    return ((_a = this.props.layout.poll) == null ? void 0 : _a.type) === LAYOUTS.GRID;
  };
  _proto.isListLayout = function isListLayout() {
    var _a;
    return ((_a = this.props.layout.poll) == null ? void 0 : _a.type) === LAYOUTS.LIST;
  };
  _proto.isImageEnabled = function isImageEnabled() {
    var _a;
    return (_a = this.props.layout.options) == null ? void 0 : _a.enableImage;
  };
  _proto.toggleVote = /*#__PURE__*/function () {
    var _toggleVote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            this.setState({
              loading: true
            });
            _context2.prev = 1;
            if (!this.isUserChoice()) {
              _context2.next = 8;
              break;
            }
            _context2.next = 5;
            return this.props.unvote(this.props.option.id);
          case 5:
            this.setState({
              checked: false
            });
            _context2.next = 11;
            break;
          case 8:
            _context2.next = 10;
            return this.props.vote(this.props.option.id);
          case 10:
            this.setState({
              checked: true
            });
          case 11:
            _context2.next = 15;
            break;
          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](1);
          case 15:
            _context2.prev = 15;
            this.setState({
              loading: false
            });
            return _context2.finish(15);
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this, [[1, 13, 15, 18]]);
    }));
    function toggleVote() {
      return _toggleVote.apply(this, arguments);
    }
    return toggleVote;
  }();
  _proto.getVotePercentage = function getVotePercentage() {
    var option = this.props.option;
    return option.rating || 0;
  };
  _proto.render = function render() {
    if (this.isViewMode()) {
      return this.renderViewMode();
    }
    return this.renderEditMode();
  };
  return PollOptionBase;
}(React.PureComponent);
__publicField$6(PollOptionBase, "propTypes", __spreadValues$6(__spreadValues$6({}, OptionPropTypes), RCEHelpersPropTypes));

var RemoveOption = function RemoveOption(_ref) {
  var onClick = _ref.onClick;
  return /* @__PURE__ */React.createElement("button", {
    "data-hook": POLLS_REMOVE_ANSWER_BUTTON,
    onClick: onClick,
    className: styles$2.removeButton
  }, /* @__PURE__ */React.createElement(RemoveIcon, {
    className: styles$2.removeButtonIcon
  }));
};

var __defProp$9 = Object.defineProperty;
var __defNormalProp$9 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$9(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField$5 = function __publicField(obj, key, value) {
  __defNormalProp$9(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var PollGridOption = /*#__PURE__*/function (_PollOptionBase) {
  function PollGridOption() {
    return _PollOptionBase.apply(this, arguments) || this;
  }
  _inheritsLoose(PollGridOption, _PollOptionBase);
  var _proto = PollGridOption.prototype;
  _proto.getCustomStyle = function getCustomStyle() {
    var _a;
    var design = this.props.design;
    var borderRadius = parseInt((_a = design.options) == null ? void 0 : _a.borderRadius);
    return {
      input: {
        borderRadius: this.isImageEnabled() ? "0 0 " + borderRadius + "px " + borderRadius + "px" : borderRadius + "px"
      },
      image: {
        borderRadius: borderRadius + "px " + borderRadius + "px 0 0"
      }
    };
  };
  _proto.renderEditMode = function renderEditMode() {
    var _cls;
    var _this$props = this.props,
      design = _this$props.design,
      option = _this$props.option,
      removeEnabled = _this$props.removeEnabled,
      dark = _this$props.dark,
      t = _this$props.t;
    var style = this.getCustomStyle();
    return /* @__PURE__ */React.createElement("div", {
      className: cls(styles$2.option, (_cls = {}, _cls[styles$2.with_image] = this.isImageEnabled(), _cls[styles$2.dark] = dark, _cls)),
      style: design.options
    }, this.isImageEnabled() && /* @__PURE__ */React.createElement(ImageUpload, {
      dataHook: POLLS_ANSWER_IMAGE,
      className: styles$2.image,
      value: option.image.src.url,
      onChange: this.handleImageChange,
      style: style.image,
      disabled: !this.isEditAllowed()
    }), /* @__PURE__ */React.createElement("div", {
      className: styles$2.title
    }, /* @__PURE__ */React.createElement(TextField, {
      dataHook: POLLS_ANSWER_TEXT_INPUT,
      disabled: !this.isEditAllowed(),
      maxLength: 60,
      style: style.input,
      className: cls(styles$2.input, styles$2.centered),
      value: option.title,
      placeholder: t("Poll_Editor_Answer_Placeholder"),
      onChange: this.handleTitleChange,
      endAdornment: /* @__PURE__ */React.createElement(React.Fragment, null, !this.isEditAllowed() ? /* @__PURE__ */React.createElement(Tooltip, {
        content: t("Poll_Editor_Answer_Error_NoEdit_Tooltip")
      }, /* @__PURE__ */React.createElement(NonEditableIcon, {
        className: styles$2.adornment_icon
      })) : null, removeEnabled && /* @__PURE__ */React.createElement(RemoveOption, {
        onClick: this.handleRemove
      }))
    })));
  };
  _proto.renderViewMode = function renderViewMode() {
    var _cls2, _cls3, _cls4;
    var _this$props2 = this.props,
      design = _this$props2.design,
      option = _this$props2.option,
      showResults = _this$props2.showResults,
      dark = _this$props2.dark,
      t = _this$props2.t;
    var _this$state = this.state,
      loading = _this$state.loading,
      checked = _this$state.checked;
    var style = this.getCustomStyle();
    return /* @__PURE__ */React.createElement("div", {
      className: cls(styles$2.option, styles$2.grid, styles$2.cta, (_cls2 = {}, _cls2[styles$2.with_image] = this.isImageEnabled(), _cls2[styles$2.user_choice] = this.isUserChoice(), _cls2[styles$2.dark] = dark, _cls2)),
      style: design.option,
      onClick: this.handleVoteClick,
      onKeyPress: this.handleVoteClick,
      "aria-label": checked ? t("Poll_Viewer_Option_AriaLabel_Checked") : t("Poll_Viewer_Option_AriaLabel_Unchecked"),
      tabIndex: 0,
      role: "button"
    }, /* @__PURE__ */React.createElement("div", {
      className: cls(styles$2.overlay, (_cls3 = {}, _cls3[styles$2.shown] = loading, _cls3)),
      style: design.option
    }, /* @__PURE__ */React.createElement(LoaderIcon, {
      className: styles$2.spinner,
      width: 36,
      height: 36
    })), this.isImageEnabled() && /* @__PURE__ */React.createElement(ImageUpload, {
      dataHook: POLLS_ANSWER_IMAGE,
      className: styles$2.image,
      value: option.image.src.url,
      style: style.image
    }), /* @__PURE__ */React.createElement("div", {
      className: styles$2.title
    }, /* @__PURE__ */React.createElement(TextField, {
      dataHook: POLLS_ANSWER_TEXT_INPUT,
      maxLength: 60,
      style: style.input,
      className: cls(styles$2.input, styles$2.centered, (_cls4 = {}, _cls4[styles$2.with_result] = showResults, _cls4)),
      value: option.title,
      placeholder: t("Poll_Editor_Answer_Placeholder")
    }, /* @__PURE__ */React.createElement("span", {
      className: styles$2.progress,
      style: {
        width: this.getVotePercentage() + "%"
      }
    }), showResults && /* @__PURE__ */React.createElement("span", {
      className: styles$2.progress_value,
      "data-hook": POLLS_ITEM_PERCENTAGE_PREVIEW
    }, this.getVotePercentage(), "%"))), /* @__PURE__ */React.createElement("div", {
      className: styles$2.check,
      style: {
        color: dark ? "#000" : design.poll.background
      }
    }, /* @__PURE__ */React.createElement(CheckIcon, {
      className: styles$2.icon
    })));
  };
  return PollGridOption;
}(PollOptionBase);
__publicField$5(PollGridOption, "propTypes", PollOptionBase.propTypes);

var __defProp$8 = Object.defineProperty;
var __defNormalProp$8 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$8(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField$4 = function __publicField(obj, key, value) {
  __defNormalProp$8(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var PollListOption = /*#__PURE__*/function (_PollOptionBase) {
  function PollListOption() {
    return _PollOptionBase.apply(this, arguments) || this;
  }
  _inheritsLoose(PollListOption, _PollOptionBase);
  var _proto = PollListOption.prototype;
  _proto.getCustomStyle = function getCustomStyle() {
    var _a;
    var design = this.props.design;
    var borderRadius = parseInt((_a = design.options) == null ? void 0 : _a.borderRadius);
    return {
      input: {
        borderRadius: borderRadius
      },
      image: {
        borderRadius: borderRadius
      }
    };
  };
  _proto.renderViewMode = function renderViewMode() {
    var _cls, _cls2, _cls3;
    var _a, _b;
    var _this$props = this.props,
      design = _this$props.design,
      option = _this$props.option,
      showResults = _this$props.showResults,
      dark = _this$props.dark,
      t = _this$props.t;
    var _this$state = this.state,
      loading = _this$state.loading,
      checked = _this$state.checked;
    var style = this.getCustomStyle();
    return /* @__PURE__ */React.createElement("div", {
      className: cls(styles$2.option, styles$2.list, styles$2.cta, (_cls = {}, _cls[styles$2.with_image] = this.isImageEnabled() ? (_a = option.image) == null ? void 0 : _a.src.url : null, _cls[styles$2.user_choice] = this.isUserChoice(), _cls[styles$2.dark] = dark, _cls)),
      style: design.option,
      onClick: this.handleVoteClick,
      onKeyPress: this.handleVoteClick,
      "aria-label": checked ? t("Poll_Viewer_Option_AriaLabel_Checked") : t("Poll_Viewer_Option_AriaLabel_Unchecked"),
      tabIndex: 0,
      role: "button"
    }, /* @__PURE__ */React.createElement("div", {
      className: cls(styles$2.overlay, (_cls2 = {}, _cls2[styles$2.shown] = loading, _cls2)),
      style: design.option
    }, /* @__PURE__ */React.createElement(LoaderIcon, {
      className: styles$2.spinner,
      width: 36,
      height: 36
    })), /* @__PURE__ */React.createElement("div", {
      className: styles$2.title
    }, /* @__PURE__ */React.createElement(TextField, {
      dataHook: POLLS_ANSWER_TEXT_INPUT,
      maxLength: 60,
      style: style.input,
      className: cls(styles$2.input, (_cls3 = {}, _cls3[styles$2.with_result] = showResults, _cls3)),
      value: option.title,
      placeholder: t("Poll_Editor_Answer_Placeholder"),
      startAdornment: this.isImageEnabled() && /* @__PURE__ */React.createElement(ImageUpload, {
        dataHook: POLLS_ANSWER_IMAGE,
        className: styles$2.image,
        value: (_b = option.image) == null ? void 0 : _b.src.url,
        style: style.image,
        small: true
      })
    }, /* @__PURE__ */React.createElement("span", {
      className: styles$2.progress,
      style: {
        width: this.getVotePercentage() + "%"
      }
    }), showResults && /* @__PURE__ */React.createElement("span", {
      className: styles$2.progress_value,
      "data-hook": POLLS_ITEM_PERCENTAGE_PREVIEW
    }, this.getVotePercentage(), "%"))), /* @__PURE__ */React.createElement("div", {
      className: styles$2.check,
      style: {
        color: dark ? "#000" : design.poll.background
      }
    }, /* @__PURE__ */React.createElement(CheckIcon, {
      className: styles$2.icon
    })));
  };
  _proto.renderEditMode = function renderEditMode() {
    var _cls4;
    var _a;
    var _this$props2 = this.props,
      design = _this$props2.design,
      option = _this$props2.option,
      removeEnabled = _this$props2.removeEnabled,
      t = _this$props2.t,
      dark = _this$props2.dark;
    var style = this.getCustomStyle();
    return /* @__PURE__ */React.createElement("div", {
      className: cls(styles$2.option, styles$2.list, (_cls4 = {}, _cls4[styles$2.with_image] = this.isImageEnabled(), _cls4[styles$2.dark] = dark, _cls4)),
      style: design.option
    }, /* @__PURE__ */React.createElement("div", {
      className: styles$2.title
    }, /* @__PURE__ */React.createElement(TextField, {
      dataHook: POLLS_ANSWER_TEXT_INPUT,
      maxLength: 60,
      style: style.input,
      className: styles$2.input,
      value: option.title,
      disabled: !this.isEditAllowed(),
      placeholder: t("Poll_Editor_Answer_Placeholder"),
      onChange: this.handleTitleChange,
      endAdornment: /* @__PURE__ */React.createElement(React.Fragment, null, !this.isEditAllowed() ? /* @__PURE__ */React.createElement(Tooltip, {
        content: t("Poll_Editor_Answer_Error_NoEdit_Tooltip")
      }, /* @__PURE__ */React.createElement(NonEditableIcon, {
        className: styles$2.adornment_icon
      })) : null, removeEnabled && /* @__PURE__ */React.createElement(RemoveOption, {
        onClick: this.handleRemove
      })),
      startAdornment: this.isImageEnabled() && /* @__PURE__ */React.createElement(ImageUpload, {
        dataHook: POLLS_ANSWER_IMAGE,
        disabled: !this.isEditAllowed(),
        className: styles$2.image,
        value: (_a = option.image) == null ? void 0 : _a.src.url,
        onChange: this.handleImageChange,
        style: style.image,
        small: true
      })
    })));
  };
  return PollListOption;
}(PollOptionBase);
__publicField$4(PollListOption, "propTypes", PollOptionBase.propTypes);

var styles$1 = {"option":"_9F576","user_choice":"YUdH3","check":"mauSt","image":"KYk7Y","input":"VZ2-d","title":"jDGdg","centered":"vVvE2","with_result":"TPY--","list":"QhRKl","with_image":"djJCL","progress":"egFk9","progress_value":"KQUzt","label":"isVfq","cta":"spFXj","adornment_icon":"Aa7Xf","remove":"_2KqA7","removeButton":"XX7tO","removeButtonIcon":"ImdmY","overlay":"AgpYj","shown":"_5c4Rm","dark":"daJGr","spinner":"GjL1-","spin":"VpJ4u","grid":"h8KcV"};

var __defProp$7 = Object.defineProperty;
var __defNormalProp$7 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$7(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField$3 = function __publicField(obj, key, value) {
  __defNormalProp$7(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var PollGridOptionWebview = /*#__PURE__*/function (_PollOptionBase) {
  function PollGridOptionWebview() {
    return _PollOptionBase.apply(this, arguments) || this;
  }
  _inheritsLoose(PollGridOptionWebview, _PollOptionBase);
  var _proto = PollGridOptionWebview.prototype;
  _proto.render = function render() {
    var _cls;
    var _this$props = this.props,
      option = _this$props.option,
      dark = _this$props.dark,
      t = _this$props.t;
    return /* @__PURE__ */React.createElement("div", {
      className: cls(styles$1.option, styles$1.grid, (_cls = {}, _cls[styles$1.with_image] = this.isImageEnabled(), _cls[styles$1.dark] = dark, _cls))
    }, this.isImageEnabled() && /* @__PURE__ */React.createElement(ImageUpload, {
      className: styles$1.image,
      value: option.image.src.url
    }), /* @__PURE__ */React.createElement("div", {
      className: styles$1.title
    }, /* @__PURE__ */React.createElement(TextField, {
      maxLength: 60,
      className: cls(styles$1.input),
      value: option.title,
      placeholder: t("Poll_Editor_Answer_Placeholder")
    })));
  };
  return PollGridOptionWebview;
}(PollOptionBase);
__publicField$3(PollGridOptionWebview, "propTypes", PollOptionBase.propTypes);

var __defProp$6 = Object.defineProperty;
var __defNormalProp$6 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$6(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField$2 = function __publicField(obj, key, value) {
  __defNormalProp$6(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var PollListOptionWebview = /*#__PURE__*/function (_PollOptionBase) {
  function PollListOptionWebview() {
    return _PollOptionBase.apply(this, arguments) || this;
  }
  _inheritsLoose(PollListOptionWebview, _PollOptionBase);
  var _proto = PollListOptionWebview.prototype;
  _proto.render = function render() {
    var _cls;
    var _this$props = this.props,
      option = _this$props.option,
      dark = _this$props.dark,
      t = _this$props.t;
    return /* @__PURE__ */React.createElement("div", {
      className: cls(styles$1.option, styles$1.list, (_cls = {}, _cls[styles$1.with_image] = this.isImageEnabled() && option.image.src.url, _cls[styles$1.dark] = dark, _cls))
    }, /* @__PURE__ */React.createElement("div", {
      className: styles$1.title
    }, /* @__PURE__ */React.createElement(TextField, {
      maxLength: 60,
      className: cls(styles$1.input),
      value: option.title,
      placeholder: t("Poll_Editor_Answer_Placeholder"),
      startAdornment: /* @__PURE__ */React.createElement(ImageUpload, {
        className: styles$1.image,
        value: option.image.src.url,
        small: true
      })
    })));
  };
  return PollListOptionWebview;
}(PollOptionBase);
__publicField$2(PollListOptionWebview, "propTypes", PollOptionBase.propTypes);

function _createForOfIteratorHelperLoose$5(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }
function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$5 = Object.defineProperty;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$5(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$5 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5) {
    for (var _iterator = _createForOfIteratorHelperLoose$5(__getOwnPropSymbols$5(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
    }
  }
  return a;
};
var PollOption = withRCEHelpers(function (props) {
  var _a, _b;
  var layout = props.layout,
    rce = props.rce;
  if (rce.isWebView) {
    switch ((_a = layout.poll) == null ? void 0 : _a.type) {
      case LAYOUTS.GRID:
        return /* @__PURE__ */React.createElement(PollGridOptionWebview, __spreadValues$5({}, props));
      case LAYOUTS.LIST:
      default:
        return /* @__PURE__ */React.createElement(PollListOptionWebview, __spreadValues$5({}, props));
    }
  }
  switch ((_b = layout.poll) == null ? void 0 : _b.type) {
    case LAYOUTS.GRID:
      return /* @__PURE__ */React.createElement(PollGridOption, __spreadValues$5({}, props));
    case LAYOUTS.LIST:
    default:
      return /* @__PURE__ */React.createElement(PollListOption, __spreadValues$5({}, props));
  }
});

var VotedUsersProps = {
  siteMembers: PropTypes.array,
  option: PropTypes.object,
  showVoters: PropTypes.bool,
  showVotes: PropTypes.bool
};

var styles = {"container":"_2CDOP","webview":"kp8FQ","avatar_list":"m8cqM","avatar":"vUl8L","user_avatar":"T8HST","modal":"SfrfC","voted_users_modal":"tAfEr","overlay":"_9Ktu7","user_card":"fRVe-","user_name":"ps-GW","voted_users_modal_header":"ATq-g","cta":"mHcHi","close_icon":"PSxRb","title":"ci5vv","member_list_container":"_4hBvI","member_list":"_97xDC","loader":"PKBKQ","anonymous_counter":"Tmi5r","spinner":"mNksQ","spin":"f0GUQ"};

function _createForOfIteratorHelperLoose$4(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }
function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$4(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$4 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4) {
    for (var _iterator = _createForOfIteratorHelperLoose$4(__getOwnPropSymbols$4(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
    }
  }
  return a;
};
var FallbackAvatar = function FallbackAvatar(props) {
  return /* @__PURE__ */React.createElement("svg", __spreadValues$4({
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */React.createElement("mask", {
    id: "mask0_51:19729",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "36",
    height: "36"
  }, /* @__PURE__ */React.createElement("circle", {
    cx: "18",
    cy: "18",
    r: "18",
    fill: "#E6E6E6"
  }), /* @__PURE__ */React.createElement("circle", {
    cx: "18",
    cy: "18",
    r: "18",
    fill: "#E6E6E6"
  })), /* @__PURE__ */React.createElement("g", {
    mask: "url(#mask0_51:19729)"
  }, /* @__PURE__ */React.createElement("circle", {
    cx: "18",
    cy: "18",
    r: "18",
    fill: "#F0F0F0"
  }), /* @__PURE__ */React.createElement("circle", {
    cx: "18",
    cy: "14",
    r: "7",
    fill: "#A6A6A6"
  }), /* @__PURE__ */React.createElement("circle", {
    cx: "18",
    cy: "41",
    r: "18",
    fill: "#A6A6A6"
  })));
};

function VoterAvatar (props) {
  var className = props.className,
    src = props.src,
    memberInfo = props.memberInfo,
    size = props.size;
  var _useContext = useContext(RicosContext),
    t = _useContext.t;
  return src ? /* @__PURE__ */React.createElement(Image, {
    uri: src,
    displayMode: "fill",
    alt: memberInfo.name || t("Polls_Plugin_User_Avatar_Alt"),
    height: size.height,
    width: size.width,
    containerProps: {
      className: className,
      style: size
    }
  }) : /* @__PURE__ */React.createElement(FallbackAvatar, {
    className: className
  });
}

function _createForOfIteratorHelperLoose$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }
function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$3(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3) {
    for (var _iterator = _createForOfIteratorHelperLoose$3(__getOwnPropSymbols$3(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
    }
  }
  return a;
};
var __publicField$1 = function __publicField(obj, key, value) {
  __defNormalProp$3(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var VotedUsersModalComponent = /*#__PURE__*/function (_Component) {
  function VotedUsersModalComponent() {
    var _this;
    _this = _Component.apply(this, arguments) || this;
    __publicField$1(_this, "state", {
      members: [],
      moreItems: true,
      cursor: void 0
    });
    __publicField$1(_this, "fetchVoters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var getSiteMember, _this$state, members, cursor, _yield$_this$props$fe, voters, moreItems;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getSiteMember = _this.props.getSiteMember;
            _this$state = _this.state, members = _this$state.members, cursor = _this$state.cursor;
            _context.prev = 2;
            _context.next = 5;
            return _this.props.fetchVoters({
              cursor: cursor,
              limit: 10
            });
          case 5:
            _yield$_this$props$fe = _context.sent;
            voters = _yield$_this$props$fe.voters;
            moreItems = _yield$_this$props$fe.moreItems;
            _this.setState({
              members: members.concat(voters.map(function (member) {
                return member.memberId;
              }).map(getSiteMember)),
              cursor: voters[voters.length - 1].memberId,
              moreItems: moreItems
            });
            _context.next = 13;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 11]]);
    })));
    return _this;
  }
  _inheritsLoose(VotedUsersModalComponent, _Component);
  var _proto = VotedUsersModalComponent.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      t = _this$props.t,
      option = _this$props.option,
      onRequestClose = _this$props.onRequestClose;
    var _this$state2 = this.state,
      members = _this$state2.members,
      moreItems = _this$state2.moreItems;
    return /* @__PURE__ */React.createElement("div", {
      className: styles.voted_users_modal
    }, /* @__PURE__ */React.createElement("div", {
      className: styles.voted_users_modal_header
    }, /* @__PURE__ */React.createElement("p", {
      className: styles.title
    }, t("Poll_Viewer_VoteCount_Modal_Voters_Header", {
      count: option.count,
      number: option.count
    })), /* @__PURE__ */React.createElement(RemoveIcon, {
      onClick: onRequestClose,
      className: styles.close_icon
    })), /* @__PURE__ */React.createElement(InfiniteScroll, {
      className: styles.member_list_container,
      initialLoad: true,
      hasMore: moreItems,
      loadMore: this.fetchVoters,
      loader: /* @__PURE__ */React.createElement("div", {
        className: styles.loader
      }, /* @__PURE__ */React.createElement(LoaderIcon, {
        width: 24,
        height: 24,
        className: styles.spinner
      }))
    }, /* @__PURE__ */React.createElement("ul", {
      className: styles.member_list
    }, members.map(function (member) {
      var _a;
      return member ? /* @__PURE__ */React.createElement("li", {
        key: member.siteMemberId
      }, /* @__PURE__ */React.createElement("div", {
        className: styles.user_card
      }, /* @__PURE__ */React.createElement(VoterAvatar, {
        className: styles.user_avatar,
        memberInfo: member,
        src: member.imageUrl,
        size: {
          width: 36,
          height: 36
        }
      }), /* @__PURE__ */React.createElement("span", {
        className: styles.user_name
      }, ((_a = member.name) == null ? void 0 : _a.nick) || t("Poll_Viewer_VoteCount_Modal_Voters_Private_Voter")))) : null;
    }))), option.anonymousCount ? /* @__PURE__ */React.createElement("p", {
      className: styles.anonymous_counter
    }, t("Poll_Viewer_VoteCount_Modal_Voters_Anonymous", {
      anonNumber: option.anonymousCount
    })) : null);
  };
  return VotedUsersModalComponent;
}(Component);
__publicField$1(VotedUsersModalComponent, "propTypes", __spreadValues$3({}, RCEHelpersPropTypes));
var VotedUsersModal = withRCEHelpers(VotedUsersModalComponent);

function _createForOfIteratorHelperLoose$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2) {
    for (var _iterator = _createForOfIteratorHelperLoose$2(__getOwnPropSymbols$2(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
    }
  }
  return a;
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp$2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var VotedUsersComponent = /*#__PURE__*/function (_PureComponent) {
  function VotedUsersComponent() {
    var _this;
    _this = _PureComponent.apply(this, arguments) || this;
    __publicField(_this, "state", {
      isOpen: false
    });
    __publicField(_this, "closeModal", function () {
      return _this.setState({
        isOpen: false
      });
    });
    __publicField(_this, "openModal", function (e) {
      var _this$props = _this.props,
        showVoters = _this$props.showVoters,
        rce = _this$props.rce;
      e.preventDefault();
      if (e.keyCode || !showVoters || rce.preventInteraction) {
        return;
      }
      _this.setState({
        isOpen: _this.props.rce.isViewMode
      });
    });
    return _this;
  }
  _inheritsLoose(VotedUsersComponent, _PureComponent);
  var _proto = VotedUsersComponent.prototype;
  _proto.getSiteMember = function getSiteMember(id) {
    var _a, _b;
    var siteMembers = ((_b = (_a = this.props.rce).getSiteMembers) == null ? void 0 : _b.call(_a)) || [];
    return siteMembers.find(function (siteMember) {
      return siteMember.siteMemberId === id;
    });
  };
  _proto.getSiteMembers = function getSiteMembers() {
    var _a, _b;
    var _this$props2 = this.props,
      rce = _this$props2.rce,
      option = _this$props2.option,
      showVoters = _this$props2.showVoters;
    var siteMembers = ((_a = rce.getSiteMembers) == null ? void 0 : _a.call(rce)) || [];
    if (!showVoters || !siteMembers) {
      return [];
    }
    return ((_b = option.latestVoters) == null ? void 0 : _b.map(this.getSiteMember.bind(this))) || [];
  };
  _proto.renderMember = function renderMember(member) {
    if (!member) {
      return null;
    }
    return /* @__PURE__ */React.createElement("li", {
      key: member.siteMemberId,
      className: styles.avatar
    }, /* @__PURE__ */React.createElement(VoterAvatar, {
      className: styles.avatar,
      memberInfo: member,
      src: member.imageUrl,
      size: {
        width: 20,
        height: 20
      }
    }));
  };
  _proto.render = function render() {
    var _classnames,
      _this2 = this;
    var _a, _b;
    var _this$props3 = this.props,
      option = _this$props3.option,
      t = _this$props3.t,
      showResults = _this$props3.showResults,
      showVotes = _this$props3.showVotes,
      showVoters = _this$props3.showVoters,
      fetchVoters = _this$props3.fetchVoters,
      rce = _this$props3.rce,
      isMobile = _this$props3.isMobile;
    var _this$state = this.state,
      isOpen = _this$state.isOpen,
      $container = _this$state.$container;
    if (!showResults || !showVotes || !option.count) {
      return null;
    }
    var zIndex = this.props.zIndexService.getZIndex(isMobile ? "DRAWER" : "DIALOG");
    return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("div", {
      className: cls(styles.container, (_classnames = {}, _classnames[styles.cta] = showVoters && ((_a = option.latestVoters) == null ? void 0 : _a.length), _classnames[styles.webview] = rce.isWebView, _classnames)),
      ref: function ref($container2) {
        return _this2.setState({
          $container: $container2
        });
      },
      onClick: this.openModal,
      onKeyPress: this.openModal,
      role: "button",
      "aria-haspopup": "dialog",
      tabIndex: 0
    }, /* @__PURE__ */React.createElement("ul", {
      className: styles.avatar_list
    }, this.getSiteMembers().map(this.renderMember)), /* @__PURE__ */React.createElement("span", {
      "data-hook": "pollsVotedUserItem"
    }, t("Poll_Viewer_VoteCount", {
      number: option.count || 0
    }))), $container && ((_b = option.latestVoters) == null ? void 0 : _b.length) ? /* @__PURE__ */React.createElement(ReactModal, {
      isOpen: isOpen,
      onRequestClose: this.closeModal,
      parentSelector: function parentSelector() {
        return document.body;
      },
      className: cls(styles.modal),
      overlayClassName: cls(styles.overlay),
      style: {
        overlay: {
          zIndex: zIndex
        }
      }
    }, /* @__PURE__ */React.createElement(VotedUsersModal, {
      option: option,
      fetchVoters: fetchVoters,
      getSiteMember: this.getSiteMember.bind(this),
      onRequestClose: this.closeModal
    })) : null);
  };
  return VotedUsersComponent;
}(PureComponent);
__publicField(VotedUsersComponent, "propTypes", __spreadValues$2({}, VotedUsersProps));
var VotedUsers = withRicosContext(withZIndexContext(withRCEHelpers(VotedUsersComponent)));

function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var PollComponent = /*#__PURE__*/function (_Component) {
  function PollComponent(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.vote = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(optionId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                error: null
              });
              _context.prev = 1;
              _context.next = 4;
              return _this.props.vote(optionId);
            case 4:
              _context.next = 11;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              console.error("[rce-social-polls] vote: ", _context.t0.response);
              _this.setState({
                error: _context.t0.message
              });
              return _context.abrupt("return", Promise.reject(_context.t0));
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 6]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    _this.unvote = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(optionId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                error: null
              });
              _context2.prev = 1;
              _context2.next = 4;
              return _this.props.unvote(optionId);
            case 4:
              _context2.next = 11;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](1);
              console.error("[rce-social-polls] unvote: ", _context2.t0.response);
              _this.setState({
                error: _context2.t0.message
              });
              return _context2.abrupt("return", Promise.reject(_context2.t0));
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 6]]);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    _this.toggleCollapse = function () {
      return _this.setState({
        collapsed: !_this.state.collapsed
      });
    };
    _this.handleCTAFocus = function (e) {
      e.stopPropagation();
      _this.props.rce.setInPluginEditingMode(true);
    };
    _this.handleCTABlur = function () {
      return _this.props.rce.setInPluginEditingMode(false);
    };
    _this.onResize = function (_ref3) {
      var bounds = _ref3.bounds;
      return _this.setState({
        bounds: bounds
      });
    };
    _this.state = {
      collapsed: _this.isInitiallyCollapsed(),
      error: null,
      loading: false,
      bounds: null
    };
    return _this;
  }
  _inheritsLoose(PollComponent, _Component);
  var _proto = PollComponent.prototype;
  _proto.componentDidMount = /*#__PURE__*/function () {
    var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var poll;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            poll = this.props.poll;
            if (poll.id) {
              this.fetchPoll();
            }
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function componentDidMount() {
      return _componentDidMount.apply(this, arguments);
    }
    return componentDidMount;
  }();
  _proto.componentDidCatch = function componentDidCatch(error) {
    this.setState({
      error: error.message
    });
  };
  _proto.fetchPoll = /*#__PURE__*/function () {
    var _fetchPoll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var t;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            t = this.context.t;
            if (!(this.props.rce.isWebView || this.props.rce.preventInteraction)) {
              _context4.next = 3;
              break;
            }
            return _context4.abrupt("return");
          case 3:
            this.setState({
              loading: true,
              error: null
            });
            _context4.prev = 4;
            _context4.next = 7;
            return this.props.fetchPoll();
          case 7:
            _context4.next = 13;
            break;
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](4);
            console.error("[rce-social-polls] fetchPoll: ", _context4.t0);
            this.setState({
              error: t("Poll_Viewer_Toast_Error_ServerDown")
            });
          case 13:
            _context4.prev = 13;
            this.setState({
              loading: false
            });
            return _context4.finish(13);
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this, [[4, 9, 13, 16]]);
    }));
    function fetchPoll() {
      return _fetchPoll.apply(this, arguments);
    }
    return fetchPoll;
  }();
  _proto.isInitiallyCollapsed = function isInitiallyCollapsed() {
    var poll = this.props.poll;
    return poll.options.length > 4;
  };
  _proto.handleOptionUpdate = function handleOptionUpdate(index) {
    var _this2 = this;
    return function (option) {
      return _this2.props.updatePollOption(index, option);
    };
  };
  _proto.handleOptionRemove = function handleOptionRemove(index) {
    var _this3 = this;
    return function () {
      return _this3.props.removeOption(index);
    };
  };
  _proto.getNotes = function getNotes() {
    var _a, _b;
    var poll = this.props.poll;
    var t = this.context.t;
    return [{
      condition: (_a = poll.settings.permissions) == null ? void 0 : _a.allowMultipleVotes,
      label: t("Poll_Viewer_Multiselect_Footer")
    }, {
      condition: ((_b = poll.settings.permissions) == null ? void 0 : _b.view) === VISIBILITY_OPTIONS.CREATOR && poll.creatorFlag,
      label: t("Poll_Viewer_Visibility_Owner_Footer")
    }].filter(function (note) {
      return !!note.condition;
    });
  };
  _proto.showResults = function showResults() {
    var _a;
    var permissions = this.props.poll.settings.permissions;
    switch (permissions == null ? void 0 : permissions.view) {
      case VISIBILITY_OPTIONS.EVERYONE:
        return true;
      case VISIBILITY_OPTIONS.VOTERS:
        return this.props.poll.creatorFlag || !!((_a = this.props.poll.ownVotes) == null ? void 0 : _a.length);
      case VISIBILITY_OPTIONS.CREATOR:
        return this.props.poll.creatorFlag;
      default:
        return false;
    }
  };
  _proto.hasImageBackground = function hasImageBackground() {
    var _a, _b, _c, _d;
    return !!((_d = (_c = (_b = (_a = this.props.design.poll) == null ? void 0 : _a.background) == null ? void 0 : _b.image) == null ? void 0 : _c.src) == null ? void 0 : _d.url);
  };
  _proto.getOptionList = function getOptionList() {
    var _this$props = this.props,
      poll = _this$props.poll,
      rce = _this$props.rce;
    var collapsed = this.state.collapsed;
    if (!rce.isViewMode || this.showEditControls()) {
      return poll.options;
    }
    var list;
    if (!this.showResults()) {
      list = poll.options;
    } else {
      list = Array.from(poll.options).sort(function (prev, option) {
        if (!prev.rating) {
          return 1;
        }
        if (option.rating === prev.rating) {
          return 0;
        }
        if (option.rating > prev.rating) {
          return 1;
        }
        return -1;
      });
    }
    return collapsed ? list.slice(0, 4) : list;
  };
  _proto.showEditControls = function showEditControls() {
    var rce = this.props.rce;
    return !rce.isViewMode && !rce.isPreview;
  };
  _proto.render = function render() {
    var _this4 = this;
    var _a, _b;
    var _this$props2 = this.props,
      poll = _this$props2.poll,
      rce = _this$props2.rce,
      getVoters = _this$props2.getVoters,
      addOption = _this$props2.addOption,
      design = _this$props2.design,
      layout = _this$props2.layout,
      siteMembers = _this$props2.siteMembers;
    var _this$state = this.state,
      collapsed = _this$state.collapsed,
      loading = _this$state.loading,
      bounds = _this$state.bounds;
    var _this$context = this.context,
      isMobile = _this$context.isMobile,
      t = _this$context.t;
    var style = __spreadProps(__spreadValues$1({}, design.poll), {
      background: toBackgroundString((_a = design.poll) == null ? void 0 : _a.background, (_b = design.poll) == null ? void 0 : _b.background.type, bounds == null ? void 0 : bounds.width, bounds == null ? void 0 : bounds.height)
    });
    return /* @__PURE__ */React.createElement(Measure, {
      bounds: true,
      onResize: this.onResize
    }, function (_ref4) {
      var _cls, _cls2, _cls3, _cls4;
      var measureRef = _ref4.measureRef;
      var _a2, _b2, _c, _d, _e, _f;
      return /* @__PURE__ */React.createElement("div", {
        className: cls(styles$6.container, (_cls = {}, _cls[styles$6.isMobile] = isMobile, _cls[styles$6.webview] = rce.isWebView, _cls[styles$6.fullscreen] = rce.isPreview, _cls[styles$6.dark] = _this4.hasImageBackground(), _cls)),
        style: style,
        dir: (_a2 = layout.poll) == null ? void 0 : _a2.direction,
        ref: measureRef,
        "data-hook": ROOT
      }, /* @__PURE__ */React.createElement("div", {
        className: cls(styles$6.background_overlay, (_cls2 = {}, _cls2[styles$6.with_image] = _this4.hasImageBackground(), _cls2))
      }), /* @__PURE__ */React.createElement(PollHeader, null), /* @__PURE__ */React.createElement("ul", {
        className: cls(styles$6.options, (_cls3 = {}, _cls3[styles$6.list] = ((_b2 = layout.poll) == null ? void 0 : _b2.type) === LAYOUTS.LIST, _cls3[styles$6.grid] = ((_c = layout.poll) == null ? void 0 : _c.type) === LAYOUTS.GRID, _cls3[styles$6.with_image] = (_d = layout.options) == null ? void 0 : _d.enableImage, _cls3))
      }, /* @__PURE__ */React.createElement(FlipMove, {
        typeName: null,
        disableAllAnimations: _this4.showEditControls(),
        enterAnimation: "none",
        leaveAnimation: "none",
        verticalAlignment: "bottom"
      }, _this4.getOptionList().map(function (option, i) {
        return /* @__PURE__ */React.createElement("li", {
          className: styles$6.option,
          key: option.id || i,
          "data-hook": POLLS_ANSWER_ITEMS
        }, /* @__PURE__ */React.createElement(PollOption, {
          option: option,
          update: _this4.handleOptionUpdate(i),
          remove: _this4.handleOptionRemove(i),
          removeEnabled: _this4.showEditControls() && poll.options.length > 1,
          vote: _this4.vote,
          unvote: _this4.unvote,
          poll: poll,
          showResults: _this4.showResults(),
          dark: _this4.hasImageBackground()
        }), /* @__PURE__ */React.createElement(VotedUsers, {
          option: option,
          siteMembers: siteMembers,
          showResults: _this4.showResults(),
          showVoters: poll.settings.showVoters,
          showVotes: poll.settings.showVotesCount,
          fetchVoters: function fetchVoters(params) {
            return getVoters(option.id, params);
          }
        }));
      }), _this4.showEditControls() && /* @__PURE__ */React.createElement("li", {
        className: styles$6.column
      }, /* @__PURE__ */React.createElement("button", {
        onClick: addOption,
        onFocus: _this4.handleCTAFocus,
        onBlur: _this4.handleCTABlur,
        className: styles$6.add_option,
        style: design.options,
        type: "button",
        "data-hook": POLLS_ADD_ANSWER_BUTTON
      }, ((_e = layout.poll) == null ? void 0 : _e.type) === LAYOUTS.GRID && ((_f = layout.options) == null ? void 0 : _f.enableImage) ? /* @__PURE__ */React.createElement(AddIcon, null) : /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(AddIcon, {
        width: 24,
        height: 24
      }), "\xA0", t("Poll_Editor_Answer_AddAnswer")))))), poll.options.length > 4 && !_this4.showEditControls() && /* @__PURE__ */React.createElement("button", {
        onClick: _this4.toggleCollapse,
        className: styles$6.see_more,
        style: design.options,
        type: "button"
      }, collapsed ? _this4.showResults() ? t("Poll_Viewer_ShowAllResults_CTA") : t("Poll_Viewer_ShowAllOptions_CTA") : t("Poll_Viewer_ShowLess_CTA")), _this4.getNotes().map(function (note, i) {
        return /* @__PURE__ */React.createElement("p", {
          className: styles$6.additional_note,
          key: i,
          "data-hook": POLLS_MULTIPLE_ANSWER_TEXT
        }, note.label);
      }), /* @__PURE__ */React.createElement(LoaderIcon, {
        className: cls(styles$6.spinner, (_cls4 = {}, _cls4[styles$6.shown] = loading, _cls4)),
        width: 24,
        height: 24
      }));
    });
  };
  return PollComponent;
}(Component);
PollComponent.propTypes = __spreadValues$1(__spreadValues$1({}, PollContextPropTypes), RCEHelpersPropTypes);
PollComponent.contextType = RicosContext;
var Poll$1 = withRCEHelpers(withPoll(PollComponent));

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var Polls = function Polls(props) {
  var _useContext = useContext(RicosContext),
    theme = _useContext.theme,
    t = _useContext.t,
    isMobile = _useContext.isMobile;
  var setPoll = function setPoll(poll) {
    var updateAttributes = props.updateAttributes;
    updateAttributes == null ? void 0 : updateAttributes({
      poll: poll
    });
  };
  var componentData = props.componentData,
    helpers = props.helpers,
    editorEvents = props.editorEvents,
    selected = props.selected,
    _props$isViewMode = props.isViewMode,
    isViewMode = _props$isViewMode === void 0 ? false : _props$isViewMode,
    settings = props.settings;
  return /* @__PURE__ */React.createElement(RCEHelpersContext.Provider, {
    value: __spreadValues({
      isViewMode: isViewMode ? isViewMode : settings.isWebView || typeof selected === "boolean" ? !selected : true,
      setInPluginEditingMode: function setInPluginEditingMode() {},
      layout: componentData.layout,
      design: componentData.design,
      preventVoting: !isViewMode,
      isPreview: isMobile,
      helpers: helpers,
      theme: theme,
      t: t,
      isMobile: isMobile
    }, settings)
  }, /* @__PURE__ */React.createElement(PollContextProvider, {
    editorEvents: editorEvents,
    settings: settings,
    poll: componentData.poll,
    setPoll: setPoll,
    t: t
  }, /* @__PURE__ */React.createElement(Poll$1, null)));
};
var PollViewer = withEditorEvents(Polls);

var Poll = function Poll(_ref) {
  var node = _ref.node,
    nodeIndex = _ref.nodeIndex,
    NodeViewContainer = _ref.NodeViewContainer;
  var _useContext = useContext(RicosViewerContext),
    config = _useContext.config;
  return /* @__PURE__ */React.createElement(NodeViewContainer, {
    node: node,
    nodeIndex: nodeIndex
  }, /* @__PURE__ */React.createElement(PollViewer, {
    componentData: node.pollData,
    settings: config[POLL_TYPE],
    isViewMode: true
  }));
};

export { Poll as default };

import 'wix-rich-content-plugin-social-polls/dist/loadable/viewer/es/styles.viewer.min.global.css'